import { Asset } from "types";

export const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://test.hrms-api.oagb.et/api/";

export const baseFileURL =
  process.env.REACT_APP_API_BASE_URL || "http://test.hrms-api.oagb.et";
export const ITEMS_PER_PAGE = 10;

export const sealCheck = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_1528_2322)">
      <path
        d="M18.1163 6.42625C17.8806 6.18 17.6369 5.92625 17.545 5.70312C17.46 5.49875 17.455 5.16 17.45 4.83187C17.4406 4.22187 17.4306 3.53062 16.95 3.05C16.4694 2.56937 15.7781 2.55937 15.1681 2.55C14.84 2.545 14.5013 2.54 14.2969 2.455C14.0744 2.36312 13.82 2.11937 13.5737 1.88375C13.1425 1.46937 12.6525 1 12 1C11.3475 1 10.8581 1.46937 10.4262 1.88375C10.18 2.11937 9.92625 2.36312 9.70312 2.455C9.5 2.54 9.16 2.545 8.83187 2.55C8.22187 2.55937 7.53062 2.56937 7.05 3.05C6.56937 3.53062 6.5625 4.22187 6.55 4.83187C6.545 5.16 6.54 5.49875 6.455 5.70312C6.36312 5.92562 6.11937 6.18 5.88375 6.42625C5.46937 6.8575 5 7.3475 5 8C5 8.6525 5.46937 9.14187 5.88375 9.57375C6.11937 9.82 6.36312 10.0737 6.455 10.2969C6.54 10.5013 6.545 10.84 6.55 11.1681C6.55937 11.7781 6.56937 12.4694 7.05 12.95C7.53062 13.4306 8.22187 13.4406 8.83187 13.45C9.16 13.455 9.49875 13.46 9.70312 13.545C9.92562 13.6369 10.18 13.8806 10.4262 14.1163C10.8575 14.5306 11.3475 15 12 15C12.6525 15 13.1419 14.5306 13.5737 14.1163C13.82 13.8806 14.0737 13.6369 14.2969 13.545C14.5013 13.46 14.84 13.455 15.1681 13.45C15.7781 13.4406 16.4694 13.4306 16.95 12.95C17.4306 12.4694 17.4406 11.7781 17.45 11.1681C17.455 10.84 17.46 10.5013 17.545 10.2969C17.6369 10.0744 17.8806 9.82 18.1163 9.57375C18.5306 9.1425 19 8.6525 19 8C19 7.3475 18.5306 6.85812 18.1163 6.42625ZM14.8538 6.85375L11.3538 10.3538C11.3073 10.4002 11.2522 10.4371 11.1915 10.4623C11.1308 10.4874 11.0657 10.5004 11 10.5004C10.9343 10.5004 10.8692 10.4874 10.8085 10.4623C10.7478 10.4371 10.6927 10.4002 10.6462 10.3538L9.14625 8.85375C9.09979 8.8073 9.06294 8.75214 9.0378 8.69145C9.01266 8.63075 8.99972 8.5657 8.99972 8.5C8.99972 8.4343 9.01266 8.36925 9.0378 8.30855C9.06294 8.24786 9.09979 8.1927 9.14625 8.14625C9.24007 8.05243 9.36732 7.99972 9.5 7.99972C9.5657 7.99972 9.63075 8.01266 9.69145 8.0378C9.75214 8.06294 9.8073 8.09979 9.85375 8.14625L11 9.29313L14.1462 6.14625C14.1927 6.09979 14.2479 6.06294 14.3086 6.0378C14.3692 6.01266 14.4343 5.99972 14.5 5.99972C14.5657 5.99972 14.6308 6.01266 14.6914 6.0378C14.7521 6.06294 14.8073 6.09979 14.8538 6.14625C14.9002 6.1927 14.9371 6.24786 14.9622 6.30855C14.9873 6.36925 15.0003 6.4343 15.0003 6.5C15.0003 6.5657 14.9873 6.63075 14.9622 6.69145C14.9371 6.75214 14.9002 6.8073 14.8538 6.85375Z"
        fill="#039D53"
      />
      <path
        d="M12 0.5C12.8873 0.5 13.5213 1.14032 13.9189 1.52246L14.0996 1.69238C14.1568 1.74537 14.2114 1.79445 14.2646 1.83887C14.3753 1.9311 14.4473 1.97658 14.4873 1.99316H14.4893L14.5664 2.01367C14.6052 2.02102 14.6582 2.02845 14.7275 2.03418C14.8588 2.04501 15.0078 2.04724 15.1758 2.0498L15.6553 2.06348C16.1813 2.09465 16.8178 2.21039 17.3037 2.69629L17.417 2.82129C17.9497 3.45766 17.9421 4.29471 17.9502 4.82422L17.9658 5.27246C17.9716 5.34182 17.979 5.39476 17.9863 5.43359L18.0068 5.51074L18.0078 5.5127L18.0557 5.59766C18.0804 5.63456 18.115 5.68003 18.1611 5.73535C18.2498 5.84163 18.356 5.9541 18.4766 6.08008L18.7979 6.42285C19.1392 6.81064 19.5 7.33395 19.5 8C19.5 8.88724 18.8587 9.52032 18.4766 9.91797L18.4775 9.91895C18.3569 10.045 18.25 10.1581 18.1611 10.2646C18.0689 10.3753 18.0234 10.4473 18.0068 10.4873V10.4893C17.9952 10.5174 17.9772 10.5896 17.9658 10.7275L17.9502 11.1758C17.9415 11.7406 17.9515 12.6559 17.3037 13.3037C16.8178 13.7896 16.1813 13.9053 15.6553 13.9365L15.1758 13.9502C15.0078 13.9528 14.8588 13.955 14.7275 13.9658C14.5896 13.9772 14.5174 13.9952 14.4893 14.0068L14.4873 14.0078C14.4473 14.0243 14.3752 14.0689 14.2646 14.1611C14.1582 14.25 14.0452 14.3567 13.9189 14.4775C13.5212 14.8592 12.8874 15.5 12 15.5C11.1127 15.5 10.4787 14.8597 10.0811 14.4775L9.90039 14.3076C9.84324 14.2546 9.78862 14.2055 9.73535 14.1611C9.62473 14.0689 9.55271 14.0234 9.5127 14.0068H9.51074C9.48265 13.9952 9.41044 13.9772 9.27246 13.9658L8.82422 13.9502C8.29471 13.9421 7.45766 13.9497 6.82129 13.417L6.69629 13.3037C6.21039 12.8178 6.09465 12.1813 6.06348 11.6553L6.0498 11.1758C6.04724 11.0078 6.04501 10.8588 6.03418 10.7275C6.02278 10.5896 6.00477 10.5174 5.99316 10.4893L5.99219 10.4873C5.97568 10.4473 5.93109 10.3752 5.83887 10.2646C5.75002 10.1582 5.64329 10.0452 5.52246 9.91895V9.91797C5.14073 9.52019 4.5 8.88707 4.5 8C4.5 7.11201 5.14141 6.47766 5.52344 6.08008C5.64376 5.95433 5.75019 5.8417 5.83887 5.73535C5.9311 5.62473 5.97658 5.55271 5.99316 5.5127V5.51074L6.01367 5.43359C6.02102 5.39476 6.02845 5.34182 6.03418 5.27246C6.04501 5.14121 6.04724 4.99221 6.0498 4.82422V4.82129L6.06445 4.34473C6.09599 3.82008 6.21032 3.18226 6.69629 2.69629L6.82129 2.58301C7.45766 2.05032 8.29471 2.05794 8.82422 2.0498L9.27344 2.03418C9.41149 2.02277 9.48286 2.00527 9.50977 1.99414L9.5127 1.99219L9.59766 1.94434C9.63456 1.91961 9.68003 1.88502 9.73535 1.83887C9.84184 1.75002 9.95478 1.64329 10.0811 1.52246C10.4788 1.14079 11.1126 0.5 12 0.5Z"
        stroke="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1528_2322"
        x="0"
        y="0"
        width="24"
        height="24"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1528_2322"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1528_2322"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export const viewIcon = (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1664_3598)">
      <path
        d="M8.63493 6.375C8.07134 6.375 7.53084 6.59888 7.13233 6.9974C6.73381 7.39591 6.50993 7.93641 6.50993 8.5C6.50993 9.06358 6.73381 9.60409 7.13233 10.0026C7.53084 10.4011 8.07134 10.625 8.63493 10.625C9.19851 10.625 9.73902 10.4011 10.1375 10.0026C10.536 9.60409 10.7599 9.06358 10.7599 8.5C10.7599 7.93641 10.536 7.39591 10.1375 6.9974C9.73902 6.59888 9.19851 6.375 8.63493 6.375ZM8.63493 12.0417C7.69562 12.0417 6.79478 11.6685 6.13059 11.0043C5.4664 10.3401 5.09326 9.43931 5.09326 8.5C5.09326 7.56069 5.4664 6.65985 6.13059 5.99566C6.79478 5.33147 7.69562 4.95833 8.63493 4.95833C9.57424 4.95833 10.4751 5.33147 11.1393 5.99566C11.8035 6.65985 12.1766 7.56069 12.1766 8.5C12.1766 9.43931 11.8035 10.3401 11.1393 11.0043C10.4751 11.6685 9.57424 12.0417 8.63493 12.0417ZM8.63493 3.1875C5.09326 3.1875 2.06868 5.39042 0.843262 8.5C2.06868 11.6096 5.09326 13.8125 8.63493 13.8125C12.1766 13.8125 15.2012 11.6096 16.4266 8.5C15.2012 5.39042 12.1766 3.1875 8.63493 3.1875Z"
        fill="#4C4C4C"
        fill-opacity="0.48"
      />
    </g>
    <defs>
      <clipPath id="clip0_1664_3598">
        <rect
          width="17"
          height="17"
          fill="white"
          transform="translate(0.133301)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const editIcon = (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.19165 14.875V11.8646L11.5417 2.53229C11.6833 2.40243 11.8399 2.30208 12.0113 2.23125C12.1827 2.16042 12.3626 2.125 12.551 2.125C12.7394 2.125 12.9224 2.16042 13.1 2.23125C13.2775 2.30208 13.431 2.40833 13.5604 2.55L14.5344 3.54167C14.676 3.67153 14.7794 3.825 14.8446 4.00208C14.9098 4.17917 14.9421 4.35625 14.9417 4.53333C14.9417 4.72222 14.9093 4.90237 14.8446 5.07379C14.7799 5.24521 14.6765 5.40151 14.5344 5.54271L5.20207 14.875H2.19165ZM12.5333 5.525L13.525 4.53333L12.5333 3.54167L11.5417 4.53333L12.5333 5.525Z"
      fill="#212121"
    />
  </svg>
);
export const deleteIcon = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1647 3.5415C14.3526 3.5415 14.5327 3.61613 14.6656 3.74897C14.7984 3.88181 14.873 4.06198 14.873 4.24984C14.873 4.4377 14.7984 4.61787 14.6656 4.7507C14.5327 4.88354 14.3526 4.95817 14.1647 4.95817H13.4564L13.4543 5.00846L12.7934 14.2671C12.7679 14.6245 12.608 14.959 12.3458 15.2032C12.0836 15.4474 11.7386 15.5832 11.3803 15.5832H5.61513C5.25681 15.5832 4.9118 15.4474 4.64959 15.2032C4.38738 14.959 4.22745 14.6245 4.20201 14.2671L3.54113 5.00917L3.53971 4.95817H2.83138C2.64352 4.95817 2.46335 4.88354 2.33051 4.7507C2.19767 4.61787 2.12305 4.4377 2.12305 4.24984C2.12305 4.06198 2.19767 3.88181 2.33051 3.74897C2.46335 3.61613 2.64352 3.5415 2.83138 3.5415H14.1647ZM9.91471 1.4165C10.1026 1.4165 10.2827 1.49113 10.4156 1.62397C10.5484 1.75681 10.623 1.93698 10.623 2.12484C10.623 2.3127 10.5484 2.49287 10.4156 2.6257C10.2827 2.75854 10.1026 2.83317 9.91471 2.83317H7.08138C6.89352 2.83317 6.71335 2.75854 6.58051 2.6257C6.44767 2.49287 6.37305 2.3127 6.37305 2.12484C6.37305 1.93698 6.44767 1.75681 6.58051 1.62397C6.71335 1.49113 6.89352 1.4165 7.08138 1.4165H9.91471Z"
      fill="#9B0505"
    />
  </svg>
);
export const closeIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8228 3.18326C10.7667 3.12701 10.7 3.08238 10.6266 3.05193C10.5532 3.02148 10.4745 3.00581 10.395 3.00581C10.3155 3.00581 10.2369 3.02148 10.1634 3.05193C10.09 3.08238 10.0234 3.12701 9.96722 3.18326L7 6.14442L4.03278 3.1772C3.9766 3.12102 3.90991 3.07646 3.8365 3.04605C3.7631 3.01565 3.68443 3 3.60499 3C3.52554 3 3.44687 3.01565 3.37347 3.04605C3.30007 3.07646 3.23337 3.12102 3.1772 3.1772C3.12102 3.23337 3.07646 3.30007 3.04605 3.37347C3.01565 3.44687 3 3.52554 3 3.60499C3 3.68443 3.01565 3.7631 3.04605 3.8365C3.07646 3.90991 3.12102 3.9766 3.1772 4.03278L6.14442 7L3.1772 9.96722C3.12102 10.0234 3.07646 10.0901 3.04605 10.1635C3.01565 10.2369 3 10.3156 3 10.395C3 10.4745 3.01565 10.5531 3.04605 10.6265C3.07646 10.6999 3.12102 10.7666 3.1772 10.8228C3.23337 10.879 3.30007 10.9235 3.37347 10.9539C3.44687 10.9844 3.52554 11 3.60499 11C3.68443 11 3.7631 10.9844 3.8365 10.9539C3.90991 10.9235 3.9766 10.879 4.03278 10.8228L7 7.85558L9.96722 10.8228C10.0234 10.879 10.0901 10.9235 10.1635 10.9539C10.2369 10.9844 10.3156 11 10.395 11C10.4745 11 10.5531 10.9844 10.6265 10.9539C10.6999 10.9235 10.7666 10.879 10.8228 10.8228C10.879 10.7666 10.9235 10.6999 10.9539 10.6265C10.9844 10.5531 11 10.4745 11 10.395C11 10.3156 10.9844 10.2369 10.9539 10.1635C10.9235 10.0901 10.879 10.0234 10.8228 9.96722L7.85558 7L10.8228 4.03278C11.0534 3.80219 11.0534 3.41385 10.8228 3.18326Z"
      fill="#AA232F"
    />
  </svg>
);
export const infoIcon = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.33333 12.5C8.56944 12.5 8.7675 12.42 8.9275 12.26C9.08694 12.1006 9.16667 11.9028 9.16667 11.6667V8.3125C9.16667 8.07639 9.08694 7.88194 8.9275 7.72917C8.7675 7.57639 8.56944 7.5 8.33333 7.5C8.09722 7.5 7.89944 7.57972 7.74 7.73917C7.58 7.89917 7.5 8.09722 7.5 8.33333V11.6875C7.5 11.9236 7.58 12.1181 7.74 12.2708C7.89944 12.4236 8.09722 12.5 8.33333 12.5ZM8.33333 5.83333C8.56944 5.83333 8.7675 5.75333 8.9275 5.59333C9.08694 5.43389 9.16667 5.23611 9.16667 5C9.16667 4.76389 9.08694 4.56583 8.9275 4.40583C8.7675 4.24639 8.56944 4.16667 8.33333 4.16667C8.09722 4.16667 7.89944 4.24639 7.74 4.40583C7.58 4.56583 7.5 4.76389 7.5 5C7.5 5.23611 7.58 5.43389 7.74 5.59333C7.89944 5.75333 8.09722 5.83333 8.33333 5.83333ZM8.33333 16.6667C7.18056 16.6667 6.09722 16.4478 5.08333 16.01C4.06944 15.5728 3.1875 14.9792 2.4375 14.2292C1.6875 13.4792 1.09389 12.5972 0.656667 11.5833C0.218889 10.5694 0 9.48611 0 8.33333C0 7.18056 0.218889 6.09722 0.656667 5.08333C1.09389 4.06944 1.6875 3.1875 2.4375 2.4375C3.1875 1.6875 4.06944 1.09361 5.08333 0.655833C6.09722 0.218611 7.18056 0 8.33333 0C9.48611 0 10.5694 0.218611 11.5833 0.655833C12.5972 1.09361 13.4792 1.6875 14.2292 2.4375C14.9792 3.1875 15.5728 4.06944 16.01 5.08333C16.4478 6.09722 16.6667 7.18056 16.6667 8.33333C16.6667 9.48611 16.4478 10.5694 16.01 11.5833C15.5728 12.5972 14.9792 13.4792 14.2292 14.2292C13.4792 14.9792 12.5972 15.5728 11.5833 16.01C10.5694 16.4478 9.48611 16.6667 8.33333 16.6667ZM8.33333 15C10.1806 15 11.7536 14.3508 13.0525 13.0525C14.3508 11.7536 15 10.1806 15 8.33333C15 6.48611 14.3508 4.91306 13.0525 3.61417C11.7536 2.31583 10.1806 1.66667 8.33333 1.66667C6.48611 1.66667 4.91333 2.31583 3.615 3.61417C2.31611 4.91306 1.66667 6.48611 1.66667 8.33333C1.66667 10.1806 2.31611 11.7536 3.615 13.0525C4.91333 14.3508 6.48611 15 8.33333 15Z"
      fill="#98B7DA"
    />
  </svg>
);
export const uploadIcon = (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.05295 16.6295H8.94709V12.6755L10.4624 14.1908L11.7883 12.8412L8.00002 9.05293L4.21174 12.8412L5.56132 14.1671L7.05295 12.6755V16.6295ZM0.423462 19.4707V0.529297H9.89416L15.5766 6.21172V19.4707H0.423462ZM8.94709 7.15879H13.6824L8.94709 2.42344V7.15879Z"
      fill="#FFF"
    />
  </svg>
);
export const uploadBlackIcon = (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.05295 16.6295H8.94709V12.6755L10.4624 14.1908L11.7883 12.8412L8.00002 9.05293L4.21174 12.8412L5.56132 14.1671L7.05295 12.6755V16.6295ZM0.423462 19.4707V0.529297H9.89416L15.5766 6.21172V19.4707H0.423462ZM8.94709 7.15879H13.6824L8.94709 2.42344V7.15879Z"
      fill="#000"
    />
  </svg>
);

export const governmentalIcon = (
  <svg
    width="38"
    height="33"
    viewBox="0 0 38 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.9998 22H26.3332V25.6667H29.9998M29.9998 14.6667H26.3332V18.3333H29.9998M33.6665 29.3333H18.9998V25.6667H22.6665V22H18.9998V18.3333H22.6665V14.6667H18.9998V11H33.6665M15.3332 7.33333H11.6665V3.66667H15.3332M15.3332 14.6667H11.6665V11H15.3332M15.3332 22H11.6665V18.3333H15.3332M15.3332 29.3333H11.6665V25.6667H15.3332M7.99984 7.33333H4.33317V3.66667H7.99984M7.99984 14.6667H4.33317V11H7.99984M7.99984 22H4.33317V18.3333H7.99984M7.99984 29.3333H4.33317V25.6667H7.99984M18.9998 7.33333V0H0.666504V33H37.3332V7.33333H18.9998Z"
      fill="#212121"
    />
  </svg>
);

export const organizationIcon = (
  <svg
    width="81"
    height="73"
    viewBox="0 0 81 73"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M64.2498 48.375H56.3332V56.2917H64.2498M64.2498 32.5417H56.3332V40.4583H64.2498M72.1665 64.2083H40.4998V56.2917H48.4165V48.375H40.4998V40.4583H48.4165V32.5417H40.4998V24.625H72.1665M32.5832 16.7083H24.6665V8.79167H32.5832M32.5832 32.5417H24.6665V24.625H32.5832M32.5832 48.375H24.6665V40.4583H32.5832M32.5832 64.2083H24.6665V56.2917H32.5832M16.7498 16.7083H8.83317V8.79167H16.7498M16.7498 32.5417H8.83317V24.625H16.7498M16.7498 48.375H8.83317V40.4583H16.7498M16.7498 64.2083H8.83317V56.2917H16.7498M40.4998 16.7083V0.875H0.916504V72.125H80.0832V16.7083H40.4998Z"
      fill="#E90102"
    />
  </svg>
);

export const personIcon = (
  <svg
    width="95"
    height="95"
    viewBox="0 0 95 95"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M66.3327 38.0833C66.3327 43.0782 64.3485 47.8686 60.8165 51.4005C57.2846 54.9324 52.4943 56.9167 47.4993 56.9167C42.5044 56.9167 37.7141 54.9324 34.1822 51.4005C30.6502 47.8686 28.666 43.0782 28.666 38.0833C28.666 33.0884 30.6502 28.2981 34.1822 24.7662C37.7141 21.2342 42.5044 19.25 47.4993 19.25C52.4943 19.25 57.2846 21.2342 60.8165 24.7662C64.3485 28.2981 66.3327 33.0884 66.3327 38.0833Z"
      fill="#E90102"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M45.5783 94.5455C20.4665 93.5379 0.416016 72.8589 0.416016 47.4998C0.416016 21.4957 21.4952 0.416504 47.4993 0.416504C73.5035 0.416504 94.5827 21.4957 94.5827 47.4998C94.5827 73.504 73.5035 94.5832 47.4993 94.5832H46.8543C46.4274 94.5832 46.0021 94.5706 45.5783 94.5455ZM17.286 77.2094C16.9339 76.1985 16.8141 75.1212 16.9354 74.0576C17.0567 72.994 17.4159 71.9714 17.9865 71.0657C18.5571 70.1599 19.3244 69.3943 20.2313 68.8257C21.1383 68.257 22.1617 67.9 23.2255 67.781C41.5786 65.7493 53.5331 65.933 71.7967 67.8233C72.862 67.9343 73.8879 68.2869 74.7963 68.8542C75.7047 69.4216 76.4717 70.1887 77.0388 71.0973C77.6059 72.0059 77.9582 73.0319 78.0689 74.0972C78.1796 75.1625 78.0457 76.239 77.6774 77.2447C85.5053 69.3253 89.8889 58.635 89.8743 47.4998C89.8743 24.0971 70.9021 5.12484 47.4993 5.12484C24.0966 5.12484 5.12435 24.0971 5.12435 47.4998C5.12435 59.0729 9.76441 69.5631 17.286 77.2094Z"
      fill="#212121"
      fill-opacity="0.32"
    />
  </svg>
);
export const emailIcon = (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.64453 20.1328C4.09453 20.1328 3.62386 19.9371 3.23253 19.5458C2.8412 19.1545 2.6452 18.6835 2.64453 18.1328V6.13281C2.64453 5.58281 2.84053 5.11215 3.23253 4.72081C3.62453 4.32948 4.0952 4.13348 4.64453 4.13281H20.6445C21.1945 4.13281 21.6655 4.32881 22.0575 4.72081C22.4495 5.11281 22.6452 5.58348 22.6445 6.13281V18.1328C22.6445 18.6828 22.4489 19.1538 22.0575 19.5458C21.6662 19.9378 21.1952 20.1335 20.6445 20.1328H4.64453ZM20.6445 8.13281L13.1695 12.8078C13.0862 12.8578 12.9989 12.8955 12.9075 12.9208C12.8162 12.9461 12.7285 12.9585 12.6445 12.9578C12.5605 12.9571 12.4732 12.9448 12.3825 12.9208C12.2919 12.8968 12.2042 12.8591 12.1195 12.8078L4.64453 8.13281V18.1328H20.6445V8.13281ZM12.6445 11.1328L20.6445 6.13281H4.64453L12.6445 11.1328ZM4.64453 8.38281V6.90781V6.93281V6.92081V8.38281Z"
      fill="black"
    />
  </svg>
);
export const passwordIcon = (
  <svg
    width="17"
    height="22"
    viewBox="0 0 17 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.64453 21.5703C2.09453 21.5703 1.62386 21.3746 1.23253 20.9833C0.841198 20.592 0.645198 20.121 0.644531 19.5703V9.57031C0.644531 9.02031 0.840531 8.54965 1.23253 8.15831C1.62453 7.76698 2.0952 7.57098 2.64453 7.57031H3.64453V5.57031C3.64453 4.18698 4.1322 3.00798 5.10753 2.03331C6.08286 1.05865 7.26186 0.57098 8.64453 0.570313C10.0272 0.569647 11.2065 1.05731 12.1825 2.03331C13.1585 3.00931 13.6459 4.18831 13.6445 5.57031V7.57031H14.6445C15.1945 7.57031 15.6655 7.76631 16.0575 8.15831C16.4495 8.55031 16.6452 9.02098 16.6445 9.57031V19.5703C16.6445 20.1203 16.4489 20.5913 16.0575 20.9833C15.6662 21.3753 15.1952 21.571 14.6445 21.5703H2.64453ZM2.64453 19.5703H14.6445V9.57031H2.64453V19.5703ZM8.64453 16.5703C9.19453 16.5703 9.66553 16.3746 10.0575 15.9833C10.4495 15.592 10.6452 15.121 10.6445 14.5703C10.6439 14.0196 10.4482 13.549 10.0575 13.1583C9.66686 12.7676 9.19586 12.5716 8.64453 12.5703C8.0932 12.569 7.62253 12.765 7.23253 13.1583C6.84253 13.5516 6.64653 14.0223 6.64453 14.5703C6.64253 15.1183 6.83853 15.5893 7.23253 15.9833C7.62653 16.3773 8.0972 16.573 8.64453 16.5703ZM5.64453 7.57031H11.6445V5.57031C11.6445 4.73698 11.3529 4.02865 10.7695 3.44531C10.1862 2.86198 9.47786 2.57031 8.64453 2.57031C7.8112 2.57031 7.10286 2.86198 6.51953 3.44531C5.9362 4.02865 5.64453 4.73698 5.64453 5.57031V7.57031Z"
      fill="black"
    />
  </svg>
);
export const LoadingIcon = (
  <svg
    className="w-5 h-5 mr-2 text-white animate-spin"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    ></circle>
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8v8H4z"
    ></path>
  </svg>
);
export const CheckIcon = (
  <svg
    width="17"
    height="12"
    viewBox="0 0 17 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 6L6 11L16 1"
      stroke="#12B76A"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const listIcon = (
  <svg
    width="17"
    height="13"
    viewBox="0 0 17 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.38984 0.929688C2.01191 0.929688 1.64946 1.07982 1.38222 1.34706C1.11498 1.6143 0.964844 1.97675 0.964844 2.35469V4.25469C0.964844 4.63262 1.11498 4.99508 1.38222 5.26231C1.64946 5.52955 2.01191 5.67969 2.38984 5.67969H4.28984C4.66778 5.67969 5.03023 5.52955 5.29747 5.26231C5.56471 4.99508 5.71484 4.63262 5.71484 4.25469V2.35469C5.71484 1.97675 5.56471 1.6143 5.29747 1.34706C5.03023 1.07982 4.66778 0.929688 4.28984 0.929688H2.38984ZM8.08984 1.87969C7.96387 1.87969 7.84305 1.92973 7.75397 2.01881C7.66489 2.10789 7.61484 2.22871 7.61484 2.35469C7.61484 2.48067 7.66489 2.60148 7.75397 2.69056C7.84305 2.77964 7.96387 2.82969 8.08984 2.82969H15.6898C15.8158 2.82969 15.9366 2.77964 16.0257 2.69056C16.1148 2.60148 16.1648 2.48067 16.1648 2.35469C16.1648 2.22871 16.1148 2.10789 16.0257 2.01881C15.9366 1.92973 15.8158 1.87969 15.6898 1.87969H8.08984ZM8.08984 3.77969C7.96387 3.77969 7.84305 3.82973 7.75397 3.91881C7.66489 4.00789 7.61484 4.12871 7.61484 4.25469C7.61484 4.38067 7.66489 4.50148 7.75397 4.59056C7.84305 4.67964 7.96387 4.72969 8.08984 4.72969H13.7898C13.9158 4.72969 14.0366 4.67964 14.1257 4.59056C14.2148 4.50148 14.2648 4.38067 14.2648 4.25469C14.2648 4.12871 14.2148 4.00789 14.1257 3.91881C14.0366 3.82973 13.9158 3.77969 13.7898 3.77969H8.08984ZM2.38984 7.57969C2.01191 7.57969 1.64946 7.72982 1.38222 7.99706C1.11498 8.2643 0.964844 8.62675 0.964844 9.00469V10.9047C0.964844 11.2826 1.11498 11.6451 1.38222 11.9123C1.64946 12.1796 2.01191 12.3297 2.38984 12.3297H4.28984C4.66778 12.3297 5.03023 12.1796 5.29747 11.9123C5.56471 11.6451 5.71484 11.2826 5.71484 10.9047V9.00469C5.71484 8.62675 5.56471 8.2643 5.29747 7.99706C5.03023 7.72982 4.66778 7.57969 4.28984 7.57969H2.38984ZM8.08984 8.52969C7.96387 8.52969 7.84305 8.57973 7.75397 8.66881C7.66489 8.75789 7.61484 8.87871 7.61484 9.00469C7.61484 9.13066 7.66489 9.25148 7.75397 9.34056C7.84305 9.42964 7.96387 9.47969 8.08984 9.47969H15.6898C15.8158 9.47969 15.9366 9.42964 16.0257 9.34056C16.1148 9.25148 16.1648 9.13066 16.1648 9.00469C16.1648 8.87871 16.1148 8.75789 16.0257 8.66881C15.9366 8.57973 15.8158 8.52969 15.6898 8.52969H8.08984ZM8.08984 10.4297C7.96387 10.4297 7.84305 10.4797 7.75397 10.5688C7.66489 10.6579 7.61484 10.7787 7.61484 10.9047C7.61484 11.0307 7.66489 11.1515 7.75397 11.2406C7.84305 11.3296 7.96387 11.3797 8.08984 11.3797H13.7898C13.9158 11.3797 14.0366 11.3296 14.1257 11.2406C14.2148 11.1515 14.2648 11.0307 14.2648 10.9047C14.2648 10.7787 14.2148 10.6579 14.1257 10.5688C14.0366 10.4797 13.9158 10.4297 13.7898 10.4297H8.08984Z"
      fill="#8D8D8D"
    />
  </svg>
);
export const searchIcon = (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.8751 13.8751L10.7989 10.7989M10.7989 10.7989C11.3251 10.2726 11.7425 9.64794 12.0273 8.96041C12.312 8.27288 12.4586 7.53599 12.4586 6.79181C12.4586 6.04764 12.312 5.31075 12.0273 4.62322C11.7425 3.93569 11.3251 3.31098 10.7989 2.78477C10.2726 2.25856 9.64794 1.84114 8.96041 1.55636C8.27288 1.27158 7.53599 1.125 6.79181 1.125C6.04764 1.125 5.31075 1.27158 4.62322 1.55636C3.93569 1.84114 3.31098 2.25856 2.78477 2.78477C1.72204 3.8475 1.125 5.28888 1.125 6.79181C1.125 8.29474 1.72204 9.73612 2.78477 10.7989C3.8475 11.8616 5.28888 12.4586 6.79181 12.4586C8.29474 12.4586 9.73612 11.8616 10.7989 10.7989Z"
      stroke="#AAAAAA"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const errorIcon = (
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 16L1.7 18.3C1.38334 18.6167 1.02067 18.6877 0.612002 18.513C0.203335 18.3383 -0.000665038 18.0257 1.62866e-06 17.575V2C1.62866e-06 1.45 0.196002 0.979002 0.588002 0.587002C0.980002 0.195002 1.45067 -0.000664969 2 1.69779e-06H18C18.55 1.69779e-06 19.021 0.196002 19.413 0.588002C19.805 0.980002 20.0007 1.45067 20 2V14C20 14.55 19.804 15.021 19.412 15.413C19.02 15.805 18.5493 16.0007 18 16H4ZM10 9.4L11.9 11.3C12.0833 11.4833 12.3167 11.575 12.6 11.575C12.8833 11.575 13.1167 11.4833 13.3 11.3C13.4833 11.1167 13.575 10.8833 13.575 10.6C13.575 10.3167 13.4833 10.0833 13.3 9.9L11.4 8L13.3 6.1C13.4833 5.91667 13.575 5.68334 13.575 5.4C13.575 5.11667 13.4833 4.88334 13.3 4.7C13.1167 4.51667 12.8833 4.425 12.6 4.425C12.3167 4.425 12.0833 4.51667 11.9 4.7L10 6.6L8.1 4.7C7.91667 4.51667 7.68333 4.425 7.4 4.425C7.11667 4.425 6.88333 4.51667 6.7 4.7C6.51667 4.88334 6.425 5.11667 6.425 5.4C6.425 5.68334 6.51667 5.91667 6.7 6.1L8.6 8L6.7 9.9C6.51667 10.0833 6.425 10.3167 6.425 10.6C6.425 10.8833 6.51667 11.1167 6.7 11.3C6.88333 11.4833 7.11667 11.575 7.4 11.575C7.68333 11.575 7.91667 11.4833 8.1 11.3L10 9.4Z"
      fill="#CC362F"
    />
  </svg>
);
export const warningIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 15C10.2833 15 10.521 14.904 10.713 14.712C10.905 14.52 11.0007 14.2827 11 14C11 13.7167 10.904 13.479 10.712 13.287C10.52 13.095 10.2827 12.9993 10 13C9.71667 13 9.479 13.096 9.287 13.288C9.095 13.48 8.99933 13.7173 9 14C9 14.2833 9.096 14.521 9.288 14.713C9.48 14.905 9.71733 15.0007 10 15ZM9 11H11V5H9V11ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6867 3.825 17.9743 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.263333 12.6833 0.000666667 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31333 4.88333 2.02567 3.825 2.925 2.925C3.825 2.025 4.88333 1.31267 6.1 0.788C7.31667 0.263333 8.61667 0.000666667 10 0C11.3833 0 12.6833 0.262667 13.9 0.788C15.1167 1.31333 16.175 2.02567 17.075 2.925C17.975 3.825 18.6877 4.88333 19.213 6.1C19.7383 7.31667 20.0007 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6867 15.1167 17.9743 16.175 17.075 17.075C16.175 17.975 15.1167 18.6877 13.9 19.213C12.6833 19.7383 11.3833 20.0007 10 20Z"
      fill="#B29C10"
    />
  </svg>
);
export const successIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 0.4375C13.1687 0.4375 15.7282 1.49765 17.6153 3.38474C19.5023 5.27182 20.5625 7.83126 20.5625 10.5C20.5625 13.1687 19.5023 15.7282 17.6153 17.6153C15.7282 19.5023 13.1687 20.5625 10.5 20.5625C7.83126 20.5625 5.27182 19.5023 3.38474 17.6153C1.49765 15.7282 0.4375 13.1687 0.4375 10.5C0.4375 7.83126 1.49765 5.27182 3.38474 3.38474C5.27182 1.49765 7.83126 0.4375 10.5 0.4375ZM9.2465 12.4852L7.01119 10.2484C6.93105 10.1683 6.83592 10.1047 6.73122 10.0614C6.62652 10.018 6.5143 9.99568 6.40097 9.99568C6.28764 9.99568 6.17542 10.018 6.07072 10.0614C5.96602 10.1047 5.87088 10.1683 5.79075 10.2484C5.62891 10.4103 5.53799 10.6298 5.53799 10.8587C5.53799 11.0875 5.62891 11.307 5.79075 11.4689L8.637 14.3151C8.71691 14.3957 8.81197 14.4596 8.9167 14.5032C9.02143 14.5468 9.13377 14.5693 9.24722 14.5693C9.36067 14.5693 9.473 14.5468 9.57773 14.5032C9.68247 14.4596 9.77753 14.3957 9.85744 14.3151L15.7512 8.41994C15.8324 8.34013 15.897 8.24504 15.9413 8.14015C15.9855 8.03525 16.0086 7.92263 16.0091 7.80878C16.0097 7.69493 15.9876 7.58209 15.9444 7.47679C15.9011 7.37149 15.8373 7.2758 15.7569 7.19525C15.6764 7.11469 15.5808 7.05087 15.4756 7.00745C15.3703 6.96403 15.2575 6.94188 15.1436 6.94227C15.0298 6.94267 14.9171 6.9656 14.8122 7.00975C14.7073 7.0539 14.6121 7.11839 14.5322 7.1995L9.2465 12.4852Z"
      fill="#198754"
    />
  </svg>
);
export const fileBigIcon = (
  <svg
    width="33"
    height="39"
    viewBox="0 0 33 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.8829 7.77336L24.5391 0.42961C24.4026 0.293259 24.2406 0.185139 24.0623 0.111425C23.884 0.0377113 23.6929 -0.00015126 23.5 4.54135e-07H8.8125C8.03343 4.54135e-07 7.28626 0.309486 6.73537 0.860374C6.18449 1.41126 5.875 2.15843 5.875 2.9375V5.875H2.9375C2.15843 5.875 1.41126 6.18449 0.860374 6.73537C0.309486 7.28626 0 8.03343 0 8.8125V35.25C0 36.0291 0.309486 36.7762 0.860374 37.3271C1.41126 37.878 2.15843 38.1875 2.9375 38.1875H23.5C24.2791 38.1875 25.0262 37.878 25.5771 37.3271C26.128 36.7762 26.4375 36.0291 26.4375 35.25V32.3125H29.375C30.1541 32.3125 30.9012 32.003 31.4521 31.4521C32.003 30.9012 32.3125 30.1541 32.3125 29.375V8.8125C32.3127 8.61957 32.2748 8.42849 32.2011 8.25019C32.1274 8.07189 32.0192 7.90986 31.8829 7.77336ZM17.625 30.8438H8.8125C8.42296 30.8438 8.04938 30.689 7.77394 30.4136C7.49849 30.1381 7.34375 29.7645 7.34375 29.375C7.34375 28.9855 7.49849 28.6119 7.77394 28.3364C8.04938 28.061 8.42296 27.9062 8.8125 27.9062H17.625C18.0145 27.9062 18.3881 28.061 18.6636 28.3364C18.939 28.6119 19.0938 28.9855 19.0938 29.375C19.0938 29.7645 18.939 30.1381 18.6636 30.4136C18.3881 30.689 18.0145 30.8438 17.625 30.8438ZM17.625 24.9688H8.8125C8.42296 24.9688 8.04938 24.814 7.77394 24.5386C7.49849 24.2631 7.34375 23.8895 7.34375 23.5C7.34375 23.1105 7.49849 22.7369 7.77394 22.4614C8.04938 22.186 8.42296 22.0312 8.8125 22.0312H17.625C18.0145 22.0312 18.3881 22.186 18.6636 22.4614C18.939 22.7369 19.0938 23.1105 19.0938 23.5C19.0938 23.8895 18.939 24.2631 18.6636 24.5386C18.3881 24.814 18.0145 24.9688 17.625 24.9688ZM29.375 29.375H26.4375V14.6875C26.4377 14.4946 26.3998 14.3035 26.3261 14.1252C26.2524 13.9469 26.1442 13.7849 26.0079 13.6484L18.6641 6.30461C18.5276 6.16826 18.3656 6.06014 18.1873 5.98642C18.009 5.91271 17.8179 5.87485 17.625 5.875H8.8125V2.9375H22.8923L29.375 9.4202V29.375Z"
      fill="#212121"
    />
  </svg>
);
export const plusIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="black" />
  </svg>
);
export const plusWhiteIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="white" />
  </svg>
);
export const audioIcon = (
  <svg
    width="18"
    height="22"
    viewBox="0 0 18 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 4.5C12.5 2.567 10.933 1 9 1C7.067 1 5.5 2.567 5.5 4.5V11C5.5 12.933 7.067 14.5 9 14.5C10.933 14.5 12.5 12.933 12.5 11V4.5Z"
      fill="black"
      stroke="black"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M1.5 10.5C1.5 14.642 4.858 18 9 18M9 18C13.142 18 16.5 14.642 16.5 10.5M9 18V21"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const attachment2Icon = (
  <svg
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1725 4.99772L5.58651 11.5837C5.39549 11.7682 5.24312 11.9889 5.13831 12.2329C5.03349 12.4769 4.97831 12.7394 4.97601 13.0049C4.9737 13.2705 5.0243 13.5338 5.12486 13.7796C5.22543 14.0254 5.37393 14.2487 5.56172 14.4365C5.7495 14.6243 5.97281 14.7728 6.2186 14.8734C6.46439 14.9739 6.72775 15.0245 6.99331 15.0222C7.25887 15.0199 7.52131 14.9647 7.76532 14.8599C8.00932 14.7551 8.23001 14.6027 8.41451 14.4117L14.8285 7.82572C15.5571 7.07131 15.9603 6.0609 15.9512 5.01212C15.9421 3.96333 15.5214 2.96008 14.7798 2.21845C14.0381 1.47682 13.0349 1.05614 11.9861 1.04703C10.9373 1.03791 9.92692 1.44109 9.17251 2.16972L2.75751 8.75472C1.63219 9.88004 1 11.4063 1 12.9977C1 14.5892 1.63219 16.1154 2.75751 17.2407C3.88282 18.366 5.40907 18.9982 7.00051 18.9982C8.59194 18.9982 10.1182 18.366 11.2435 17.2407L17.5005 10.9977"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const eyeIcon = (
  <svg
    width="22"
    height="14"
    viewBox="0 0 22 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_2951_36907"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="22"
      height="14"
    >
      <path
        d="M10.6666 13C16.1896 13 20.6666 7 20.6666 7C20.6666 7 16.1896 1 10.6666 1C5.14363 1 0.666626 7 0.666626 7C0.666626 7 5.14363 13 10.6666 13Z"
        fill="white"
        stroke="white"
        stroke-width="1.33333"
        stroke-linejoin="round"
      />
      <path
        d="M10.6666 9.5C11.3297 9.5 11.9656 9.23661 12.4344 8.76777C12.9032 8.29893 13.1666 7.66304 13.1666 7C13.1666 6.33696 12.9032 5.70107 12.4344 5.23223C11.9656 4.76339 11.3297 4.5 10.6666 4.5C10.0036 4.5 9.3677 4.76339 8.89886 5.23223C8.43002 5.70107 8.16663 6.33696 8.16663 7C8.16663 7.66304 8.43002 8.29893 8.89886 8.76777C9.3677 9.23661 10.0036 9.5 10.6666 9.5Z"
        fill="black"
        stroke="black"
        stroke-width="1.33333"
        stroke-linejoin="round"
      />
    </mask>
    <g mask="url(#mask0_2951_36907)">
      <path d="M-1.33337 -5H22.6666V19H-1.33337V-5Z" fill="#EFC83D" />
    </g>
  </svg>
);
export const actionListIcon = (
  <svg
    width="24"
    height="14"
    viewBox="0 0 24 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 0.5H9C7.9 0.5 7 1.4 7 2.5V11.5C7 12.0304 7.21071 12.5391 7.58579 12.9142C7.96086 13.2893 8.46957 13.5 9 13.5H22C23.11 13.5 24 12.61 24 11.5V2.5C24 1.96957 23.7893 1.46086 23.4142 1.08579C23.0391 0.710714 22.5304 0.5 22 0.5ZM22 4.17L15.5 7.5L9 4.17V2.5L15.5 5.81L22 2.5V4.17ZM5 11.5C5 11.67 5.03 11.83 5.05 12H1C0.448 12 0 11.55 0 11C0 10.45 0.448 10 1 10H5V11.5ZM3 2H5.05C5.03 2.17 5 2.33 5 2.5V4H3C2.45 4 2 3.55 2 3C2 2.45 2.45 2 3 2ZM1 7C1 6.45 1.45 6 2 6H5V8H2C1.45 8 1 7.55 1 7Z"
      fill="#212121"
    />
  </svg>
);
export const feedbackIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.8 12.2V6H2C0.9 6 0 6.9 0 8V14C0 15.1 0.9 16 2 16H3V19L6 16H11C12.1 16 13 15.1 13 14V12.18C12.9342 12.1937 12.8672 12.2007 12.8 12.201H5.8V12.2ZM18 1H9C7.9 1 7 1.9 7 3V11H14L17 14V11H18C19.1 11 20 10.101 20 9V3C20 1.9 19.1 1 18 1Z"
      fill="black"
    />
  </svg>
);
export const reportTimeBlackIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 27.38V20H27V25.64L31.88 28.46L30.38 31.06L24 27.38ZM0 38V0H36V16.2C38.48 18.72 40 22.18 40 26C40 33.74 33.74 40 26 40C24.0727 40.0054 22.1653 39.6099 20.399 38.8386C18.6327 38.0674 17.0461 36.9372 15.74 35.52L12 38L6 34L0 38ZM13.34 20C14.06 18.5 15 17.14 16.2 16H8V20H13.34ZM28 12V8H8V12H28ZM26 36C31.52 36 36 31.52 36 26C36 20.48 31.52 16 26 16C20.48 16 16 20.48 16 26C16 31.52 20.48 36 26 36Z"
      fill="#212121"
    />
  </svg>
);
export const fileIcon = (
  <svg
    width="12"
    height="15"
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66602 5.5026V1.83594L10.3327 5.5026M1.99935 0.835938C1.25935 0.835938 0.666016 1.42927 0.666016 2.16927V12.8359C0.666016 13.1896 0.806491 13.5287 1.05654 13.7787C1.30659 14.0288 1.64573 14.1693 1.99935 14.1693H9.99935C10.353 14.1693 10.6921 14.0288 10.9422 13.7787C11.1922 13.5287 11.3327 13.1896 11.3327 12.8359V4.83594L7.33268 0.835938H1.99935Z"
      fill="#212121"
    />
  </svg>
);
export const reportTimeWhiteIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 27.38V20H27V25.64L31.88 28.46L30.38 31.06L24 27.38ZM0 38V0H36V16.2C38.48 18.72 40 22.18 40 26C40 33.74 33.74 40 26 40C24.0727 40.0054 22.1653 39.6099 20.399 38.8386C18.6327 38.0674 17.0461 36.9372 15.74 35.52L12 38L6 34L0 38ZM13.34 20C14.06 18.5 15 17.14 16.2 16H8V20H13.34ZM28 12V8H8V12H28ZM26 36C31.52 36 36 31.52 36 26C36 20.48 31.52 16 26 16C20.48 16 16 20.48 16 26C16 31.52 20.48 36 26 36Z"
      fill="white"
    />
  </svg>
);
export const reportTimeRedIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 27.38V20H27V25.64L31.88 28.46L30.38 31.06L24 27.38ZM0 38V0H36V16.2C38.48 18.72 40 22.18 40 26C40 33.74 33.74 40 26 40C24.0727 40.0054 22.1653 39.6099 20.399 38.8386C18.6327 38.0674 17.0461 36.9372 15.74 35.52L12 38L6 34L0 38ZM13.34 20C14.06 18.5 15 17.14 16.2 16H8V20H13.34ZM28 12V8H8V12H28ZM26 36C31.52 36 36 31.52 36 26C36 20.48 31.52 16 26 16C20.48 16 16 20.48 16 26C16 31.52 20.48 36 26 36Z"
      fill="#9D0D0F"
    />
  </svg>
);
export const personWhiteIcon = (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.0013 2.16406C14.4239 2.16406 15.8327 2.44426 17.147 2.98869C18.4614 3.53311 19.6557 4.33108 20.6616 5.33705C21.6676 6.34302 22.4656 7.53727 23.01 8.85164C23.5544 10.166 23.8347 11.5747 23.8347 12.9974C23.8347 18.9805 18.9844 23.8307 13.0013 23.8307C7.01824 23.8307 2.16797 18.9805 2.16797 12.9974C2.16797 7.01433 7.01824 2.16406 13.0013 2.16406ZM14.0847 14.0807H11.918C9.23596 14.0807 6.93338 15.7051 5.94025 18.0238C7.51163 20.2273 10.0887 21.6641 13.0013 21.6641C15.9139 21.6641 18.4909 20.2273 20.0624 18.0237C19.0692 15.7051 16.7667 14.0807 14.0847 14.0807ZM13.0013 5.41406C11.2064 5.41406 9.75129 6.86915 9.75129 8.66406C9.75129 10.459 11.2064 11.9141 13.0013 11.9141C14.7962 11.9141 16.2513 10.459 16.2513 8.66406C16.2513 6.86915 14.7963 5.41406 13.0013 5.41406Z"
      fill="white"
    />
  </svg>
);
export const viewWhiteIcon = (
  <svg
    width="16"
    height="10"
    viewBox="0 0 16 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.9974 3C7.46696 3 6.95825 3.21071 6.58318 3.58579C6.20811 3.96086 5.9974 4.46957 5.9974 5C5.9974 5.53043 6.20811 6.03914 6.58318 6.41421C6.95825 6.78929 7.46696 7 7.9974 7C8.52783 7 9.03654 6.78929 9.41161 6.41421C9.78668 6.03914 9.9974 5.53043 9.9974 5C9.9974 4.46957 9.78668 3.96086 9.41161 3.58579C9.03654 3.21071 8.52783 3 7.9974 3ZM7.9974 8.33333C7.11334 8.33333 6.26549 7.98214 5.64037 7.35702C5.01525 6.7319 4.66406 5.88406 4.66406 5C4.66406 4.11595 5.01525 3.2681 5.64037 2.64298C6.26549 2.01786 7.11334 1.66667 7.9974 1.66667C8.88145 1.66667 9.7293 2.01786 10.3544 2.64298C10.9795 3.2681 11.3307 4.11595 11.3307 5C11.3307 5.88406 10.9795 6.7319 10.3544 7.35702C9.7293 7.98214 8.88145 8.33333 7.9974 8.33333ZM7.9974 0C4.66406 0 1.8174 2.07333 0.664062 5C1.8174 7.92667 4.66406 10 7.9974 10C11.3307 10 14.1774 7.92667 15.3307 5C14.1774 2.07333 11.3307 0 7.9974 0Z"
      fill="white"
    />
  </svg>
);
export const localizationIcon = (
  <svg
    width="20"
    height="20"
    viewBox="285 14 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g data-figma-bg-blur-radius="19.4">
      <path
        d="M295 34C293.633 34 292.342 33.7373 291.125 33.212C289.908 32.6867 288.846 31.97 287.938 31.062C287.03 30.154 286.313 29.0917 285.788 27.875C285.263 26.6583 285 25.3667 285 24C285 22.6167 285.263 21.321 285.788 20.113C286.313 18.905 287.03 17.8467 287.938 16.938C288.846 16.0293 289.908 15.3127 291.125 14.788C292.342 14.2633 293.633 14.0007 295 14C296.383 14 297.679 14.2627 298.888 14.788C300.097 15.3133 301.155 16.03 302.062 16.938C302.969 17.846 303.686 18.9043 304.212 20.113C304.738 21.3217 305.001 22.6173 305 24C305 25.3667 304.737 26.6583 304.212 27.875C303.687 29.0917 302.97 30.1543 302.062 31.063C301.154 31.9717 300.096 32.6883 298.887 33.213C297.678 33.7377 296.383 34 295 34ZM295 31.95C295.433 31.35 295.808 30.725 296.125 30.075C296.442 29.425 296.7 28.7333 296.9 28H293.1C293.3 28.7333 293.558 29.425 293.875 30.075C294.192 30.725 294.567 31.35 295 31.95ZM292.4 31.55C292.1 31 291.838 30.429 291.613 29.837C291.388 29.245 291.201 28.6327 291.05 28H288.1C288.583 28.8333 289.188 29.5583 289.913 30.175C290.638 30.7917 291.467 31.25 292.4 31.55ZM297.6 31.55C298.533 31.25 299.363 30.7917 300.088 30.175C300.813 29.5583 301.417 28.8333 301.9 28H298.95C298.8 28.6333 298.613 29.246 298.388 29.838C298.163 30.43 297.901 31.0007 297.6 31.55ZM287.25 26H290.65C290.6 25.6667 290.563 25.3377 290.538 25.013C290.513 24.6883 290.501 24.3507 290.5 24C290.499 23.6493 290.512 23.312 290.538 22.988C290.564 22.664 290.601 22.3347 290.65 22H287.25C287.167 22.3333 287.104 22.6627 287.063 22.988C287.022 23.3133 287.001 23.6507 287 24C286.999 24.3493 287.02 24.687 287.063 25.013C287.106 25.339 287.168 25.668 287.25 26ZM292.65 26H297.35C297.4 25.6667 297.438 25.3377 297.463 25.013C297.488 24.6883 297.501 24.3507 297.5 24C297.499 23.6493 297.487 23.312 297.462 22.988C297.437 22.664 297.4 22.3347 297.35 22H292.65C292.6 22.3333 292.563 22.6627 292.538 22.988C292.513 23.3133 292.501 23.6507 292.5 24C292.499 24.3493 292.512 24.687 292.538 25.013C292.564 25.339 292.601 25.668 292.65 26ZM299.35 26H302.75C302.833 25.6667 302.896 25.3377 302.938 25.013C302.98 24.6883 303.001 24.3507 303 24C302.999 23.6493 302.979 23.312 302.938 22.988C302.897 22.664 302.835 22.3347 302.75 22H299.35C299.4 22.3333 299.438 22.6627 299.463 22.988C299.488 23.3133 299.501 23.6507 299.5 24C299.499 24.3493 299.487 24.687 299.462 25.013C299.437 25.339 299.4 25.668 299.35 26ZM298.95 20H301.9C301.417 19.1667 300.813 18.4417 300.088 17.825C299.363 17.2083 298.534 16.75 297.6 16.45C297.9 17 298.163 17.571 298.388 18.163C298.613 18.755 298.801 19.3673 298.95 20ZM293.1 20H296.9C296.7 19.2667 296.442 18.575 296.125 17.925C295.808 17.275 295.433 16.65 295 16.05C294.567 16.65 294.192 17.275 293.875 17.925C293.558 18.575 293.3 19.2667 293.1 20ZM288.1 20H291.05C291.2 19.3667 291.388 18.754 291.613 18.162C291.838 17.57 292.101 16.9993 292.4 16.45C291.467 16.75 290.637 17.2083 289.912 17.825C289.187 18.4417 288.583 19.1667 288.1 20Z"
        fill="#AEAEAE"
      />
    </g>
  </svg>
);
export const notificationicon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    style={{ padding: 0, margin: 0 }} // Remove any default padding/margin
  >
    <path
      d="M12 22c1.1 0 2-.9 2-2h-4a2 2 0 002 2zm6-6v-5a6 6 0 10-12 0v5l-2 2v1h16v-1l-2-2z"
      stroke="#AEAEAE"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);
export const pdfIcon = (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="47" height="47" rx="3.5" fill="#E6E6E6" />
    <rect x="0.5" y="0.5" width="47" height="47" rx="3.5" stroke="#432101" />
    <g clip-path="url(#clip0_1_71789)">
      <path
        d="M15.7665 24.9646H14.7998V23.0312H15.7665C16.0228 23.0312 16.2687 23.1331 16.45 23.3144C16.6313 23.4957 16.7331 23.7415 16.7331 23.9979C16.7331 24.2543 16.6313 24.5002 16.45 24.6815C16.2687 24.8627 16.0228 24.9646 15.7665 24.9646ZM22.5331 28.8313V23.0312H23.4998C23.7562 23.0312 24.0021 23.1331 24.1833 23.3144C24.3646 23.4957 24.4665 23.7415 24.4665 23.9979V27.8646C24.4665 28.121 24.3646 28.3668 24.1833 28.5481C24.0021 28.7294 23.7562 28.8313 23.4998 28.8313H22.5331Z"
        fill="#432101"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.9336 12.4C10.9336 11.6309 11.2391 10.8932 11.783 10.3494C12.3268 9.80553 13.0645 9.5 13.8336 9.5H29.7005L36.0669 15.8665V35.6C36.0669 36.3691 35.7614 37.1068 35.2175 37.6506C34.6737 38.1945 33.9361 38.5 33.1669 38.5H13.8336C13.0645 38.5 12.3268 38.1945 11.783 37.6506C11.2391 37.1068 10.9336 36.3691 10.9336 35.6V12.4ZM15.7669 21.1H12.8669V30.7667H14.8003V26.9H15.7669C16.5361 26.9 17.2737 26.5945 17.8175 26.0506C18.3614 25.5068 18.6669 24.7691 18.6669 24C18.6669 23.2309 18.3614 22.4932 17.8175 21.9494C17.2737 21.4055 16.5361 21.1 15.7669 21.1ZM23.5003 21.1H20.6003V30.7667H23.5003C24.2694 30.7667 25.007 30.4611 25.5509 29.9173C26.0947 29.3734 26.4003 28.6358 26.4003 27.8667V24C26.4003 23.2309 26.0947 22.4932 25.5509 21.9494C25.007 21.4055 24.2694 21.1 23.5003 21.1ZM28.3336 30.7667V21.1H34.1336V23.0333H30.2669V24.9667H32.2003V26.9H30.2669V30.7667H28.3336Z"
        fill="#432101"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_71789">
        <rect
          width="29"
          height="29"
          fill="white"
          transform="translate(9 9.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const returnIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 7L9 2 4 7"
      stroke="#212121"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M9 2v13a4 4 0 004 4h6"
      stroke="#212121"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export const fileUploadIcon = (
  <svg
    className="w-12 h-8 text-gray-400 mb-2"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    style={{ margin: "0 auto" }}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
    />
  </svg>
);
export const getMappingDisplayText = (mapping: any) => {
  const assetNumbers = mapping.assets
    ?.map((a: Asset) => a.asset_number || a.asset_unique_id)
    .filter(Boolean)
    .join(", ");

  const suspectNames = mapping.asset_suspects
    ?.map((s: any) => s.person?.full_name)
    .filter(Boolean)
    .join(", ");

  if (assetNumbers && suspectNames) {
    return `Assets: ${assetNumbers} | Suspects: ${suspectNames}`;
  } else if (assetNumbers) {
    return `Assets: ${assetNumbers}`;
  } else if (suspectNames) {
    return `Suspects: ${suspectNames}`;
  }
  return `Mapping ID: ${mapping.id}`;
};
